import { WebappApiResponse } from '@/lib/types/request/request';
import Employee from '@/modules/people/types/employee';
import { get } from '@webapp-next/lib/request/webapp/http';

interface Params {
  employeeId: number;
  effectiveDate?: string;
  skipAgreements?: boolean;
}
export default async function employeeGetWithFilters({
  employeeId,
  effectiveDate,
  skipAgreements,
}: Params): Promise<WebappApiResponse<Employee, Record<string, unknown>>> {
  try {
    const queryParameters: string[] = [];
    if (effectiveDate) {
      queryParameters.push(`effectiveDate=${encodeURIComponent(effectiveDate)}`);
    }
    if (skipAgreements === true) {
      queryParameters.push('skipAgreements=true');
    }
    const queryString =
      queryParameters.length > 0 ? `?${queryParameters.join('&')}` : '';

    const { data } = await get(
      `api/v1/supervise/employee/${employeeId}${queryString}`
    );

    return {
      success: true,
      message: '',
      data: data || {},
    };
  } catch (e) {
    console.error(e);
    throw e;
  }
}
